import { useLocation } from "wouter";
import { BottomNav } from "./BottomNav";

interface MobileLayoutProps {
  children: React.ReactNode;
}

export function MobileLayout({ children }: MobileLayoutProps) {
  const [location] = useLocation();
  const isChatDetail = location.startsWith("/chats/") && location !== "/chats";

  return (
    <div className={`min-h-screen bg-background ${!isChatDetail ? "pb-16" : ""}`}>
      <main className="min-h-screen transition-all duration-300">
        {children}
      </main>
      {!isChatDetail && <BottomNav />}
    </div>
  );
}
